import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles';
import { installRandomUuidPolyfill } from './utils/randomUuid';

// Antes de renderizar: el WebView de Android 11 (Chromium 83, el del Scangle SP01) no trae
// `crypto.randomUUID`, y el POS lo usa para las claves de idempotencia.
installRandomUuidPolyfill();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
